// Helper utility to add class to elements if condition is true, which hide that element from dom. (The added class have "display: none" rule.)
// Ex. <div className={`${cssHideIf(name==='hello')}`}>ABC</div>
export function cssHideIf(condition) {
	if (condition) {
		return 'GC-UTL-hideElement';
	} else {
		return '';
	}
}
